const announcement_utils = {
    title: {
        minLength: 1,
        maxLength: 255
    },
    message: {
        minLength: 1,
        maxLength: 5000
    },
    date_scheduled: {
        minOffset: 30, // Minutes
        validationOffset: 25 // Minutes
    },
    send_to: [
        {
            name: 'team',
            label: 'mobile_common_filter_team'
        },
        {
            name: 'role',
            label: 'mobile_announcement_send_to_role'
        },
        {
            name: 'user',
            label: 'mobile_batch_estimate_user'
        }
    ],
    scheduled_date: [
        {
            name: 'immediately',
            label: 'mobile_scheduled_announcements_send_immediately_label'
        },
        {
            name: 'scheduled',
            label: 'mobile_scheduled_announcements_scheduled_label'
        }
    ],
    order_by: {
        scheduled: 'date_scheduled',
        sent: '-date_created'
    },
    status: {
        scheduled: 'scheduled',
        sent: 'sent'
    },
    default_list_tab: 'sent_announcements',
    utils: {
        get_datetime_with_timezone: function (timestamp) {
            if (!timestamp) {
                return null;
            }

            const current_tz = moment.tz.guess();
            return moment(timestamp).tz(current_tz).format($f.utils.DATE_AND_TIME_FMT);
        }
    }
};

export default announcement_utils;
